import { render, staticRenderFns } from "./SmallDetailsMonitor.vue?vue&type=template&id=b5d22688"
import script from "./SmallDetailsMonitor.vue?vue&type=script&lang=ts"
export * from "./SmallDetailsMonitor.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports